export const ES = {
  "Trips": "Bueno Trips",
  "USER_PROFILE": "Perfil del usuario",
  "USER_DETAILS": "Detalles de usuario",
  "DETAILS": "Detalles",
  "CONTACT_DETAILS": "Detalles de contacto",
  "ADDRESSES": "Direcciones",
  "FIRST_NAME": "Nombre de pila",
  "LAST_NAME": "Apellido",
  "MIDDLE_INITIAL": "inicial del segundo nombre",
  "GENDER": "Género",
  "DATE_OF_BIRTH": "Fecha de nacimiento",
  "AGE": "Años",
  "PRIMARY_LANGUAGE": "Lenguaje primario",
  "PHONE_NUMBERS": "Números de teléfono",
  "HOME": "Hogar",
  "WORK": "Trabajo",
  "EMAIL_ADDRESSES": "Correos electrónicos",
  "PHYSICAL_ADDRESSES": "Direcciones fisicas",
  "ADDRESS": "la dirección",
  "CITY": "Ciudad",
  "STATE": "Estado",
  "ZIP": "Código Postal",
  "MAILING_ADDRESS": "Dirección de envio",
  "CURRENT_LANGUAGE": "Spanish",
  "MONTH": "Mes",
  "DAY": "Dia",
  "SAVE": "Salvar",
  "DAILY": "Diario",
  "PREVIOUS_MONTH_LINK": "{{ visibleTabs }} meses anteriores",
  "NEXT_MONTH_LINK": "Próximos {{ visibleTabs }} meses",
  "PREVIOUS_WEEK_LINK": "{{ visibleDays }} días anteriores",
  "NEXT_WEEK_LINK": "Próximos {{ visibleDays }} días",
  "STATUS": "Estado",
  "APPOINTMENT_TIME": "Hora de la cita",
  "PICKUP_TIME": "Hora de recogida",
  "PICKUP_ADDRESS": "Dirección de entrega",
  "DROPOFF_ADDRESS": "Dirección de entrega",
  "PROVIDER_NAME": "Nombre del proveedor",
  "PROVIDER_PHONE": "Número de teléfono del proveedor",
  "TRANSPORTATION_PROVIDER": "Proveedor de transporte",
  "ARRIVE_BY": "Llegar por",
  "DEPART_AFTER": "Partirá después",
  "MEDICAL_FACILITY": "Centro Médico",
  "MEDICAL_NUMBER": "Número médico",
  "TRIP_REASON": "Razón del viaje",
  "MODE": "Modo",
  "TRIP_MILES": "Millas de viaje",
  "TRIPS": "Excursiones",
  "TRIP_DETAILS": "Detalles del viaje",
  "BACK": "atrás",
  "MONTH_CALENDAR_DISABLED_TEXT":
    "MTM solo muestra 12 meses en el pasado o 6 meses en el futuro.",
  "NO_TRIPS": "No hay viajes programados",
  "TRIPS_ON": "Viajes el",
  "PENDING_ASSIGNMENT": "Asignación pendiente",
  "ACCOUNT_SETTINGS": "Configuraciones de la cuenta",
  "HELP": "Ayuda",
  "SIGNOUT": "desconectar",
  "MENU_GMR": "Reclamar viaje GMR",
  "MENU_WMR": "Dónde está mi paseo",
  "MENU_USERS": "Los usuarios",
  "MENU_SETUP": "Configuración",
  "COMMUNICATION_PREFERENCES": "preferencia de comunicacion",
  "EMAILS": "Correos electrónicos",
  "TEXT_MESSAGES": "Mensajes de texto",
  "PHONE_CALLS": "Llamadas telefónicas",
  "MEDICAL_HEALTH_PLAN": "Plan de salud médica",
  "PLAN_DETAILS": "Detalles del plan",
  "BENEFIT_GROUP": "Grupo de beneficios",
  "HEALTH_PLAN_ID": "ID del plan de salud",
  "MEDICAL_ID": "Identificación médica",
  "EFFECTIVE_DATE": "Fecha efectiva",
  "PERSON_COVERED": "Persona cubierta",
  "NAME": "Nombre",
  "PHONE": "Teléfono",
  "AUTOMATED_UPDATES_MESSAGE":
    "Cómo le gustaría recibir actualizaciones automáticas sobre su viaje?",
  "CANCEL_BTN": "Cancelar",
  "BACK_BTN": "Atrás",
  "THIS_STOP_BTN": "Cancelar detener",
  "CANCEL_STOPS_MSG": "¿Qué parada quieres cancelar?",
  "ALL_STOPS_BTN": "Todas las paradas",
  "SUBMIT_BTN": "Enviar",
  "CANCEL_SINGLE_WARNING_MSG":
    "¿Seguro que quieres cancelar este viaje? No se puede deshacer una vez que se hace clic en enviar.",
  "CANCEL_MULTIPLE_WARNING_MSG":
    "¿Seguro que quieres cancelar estos viajes? No se puede deshacer una vez que se hace clic en enviar.",
  "SCHEDULED_PICKUP": "Recogida programada",
  "SHOW_CANCELLED_TRIPS": "Mostrar viajes cancelados",
  "HEALTH_COVERAGE_DETAILS": "Detalles de cobertura de salud",
  "CANCEL_MORE_THAN_TWO_MSG":
    "Para fines de precisión, comuníquese con MTM si desea cancelar solo una parte de este viaje.",
  "CANCEL_ALL_BTN": "Cancelar todas las paradas",
  "HEALTH_COVERAGE_TOOLTIP":
    "Esta información proviene de su plan de salud. Si es incorrecto, comuníquese con su plan de salud para actualizarlo.",
  "MONTH_CALENDAR_ICON_TEXT":
    ",Los viajes están programados para el  {{tripDate}}",
  "ARIA_DAILY_TAB": "Pestaña diaria",
  "ARIA_MONTHLY_TAB": "Pestaña mensual",
  "ARIA_CANCEL_TRIP": "cancelar viaje",
  "ARIA_VIEW_TRIP_DETAILS": "ver detalles del viaje",
  "ARIA_TRIPS_PAGE": "página de viajes",
  "ALT_EDIT_CONTACT_DETAILS": "editar detalles de contacto",
  "ALT_EDIT_COMM_PREFS": "editar preferencias de comunicación",
  "ALT_EDIT_ADDRESSES": "editar direcciones",
  "SET_DEFAULT_LANGUAGE": "selector de idioma",
  "USER_MENU": "Menú del Usuario",
  "APPLICATIONS": "Aplicaciones",
  "LANGUAGE": "Idioma",
  "API_ERROR_MSG": "Había un problema. Inténtalo de nuevo.",
  "YOUR_RIDE_ON": "Su paseo en",
  "FROM": "desde",
  "TO": "a",
  "ARRIVING_BY": "llegando por",
  "DEPARTING_AFTER": "saliendo después",
  "HAS_BEEN_CANCELLED": "ha sido cancelado",
  "SELECTED": "Seleccionado",
  "TRIP": "Viaje",
  "CANCEL_WARNING_TRIP":
    "¿Seguro que quieres cancelar este viaje? No se puede deshacer una vez que se hace clic en Sí",
  "CANCEL_WARNING_TRIPS":
    "¿Estás seguro de que deseas cancelar estos viajes? No se puede deshacer una vez que se hace clic en Sí",
  "MENU_REQUEST_RIDE": "Solicitar un paseo",
  "REQUEST_RIDE_PAGE": "Solicitar una página de viaje",
  "RAR_STEP_1_QUESTION": "¿Qué día necesitas que te recojamos?",
  "APPOINTMENT_INFO_TITLE": "Información sobre citas en",
  "WHERE_PICK_UP": "¿Dónde deberíamos recogerte?",
  "WHAT_TIME_APPOINTMENT": "¿A qué hora es tu cita?",
  "WHAT_TIME_PICKUP": "¿A qué hora deberíamos recogerte?",
  "WHERE_YOUR_DROPOFF": "¿Dónde deberíamos dejarte?",
  "WHERE_YOUR_APPOINTMENT": "¿Dónde está tu cita?",
  "WHAT_REASON_APPOINTMENT": "¿Cuál es el motivo de su cita?",
  "RAR_NEXT_BTN": "Próximo",
  "RAR_BACK_BTN": "Atrás",
  "ADD_STOP": "Agregar parada",
  "APPOINTMENT": "Cita",
  "WHAT_TIME": "¿Qué hora?",
  "WHERE_TO": "¿A donde?",
  "APPOINTMENT_REASON": "Motivo de la cita?",
  "ADDITIONAL_PASSENGER": "Pasajero adicional",
  "ADDITIONAL_PASSENGERS": "Pasajeros adicionales",
  "ADD_PASSENGER": "Agregar pasajero",
  "PASSENGER_INFORMATION": "Información del pasajero",
  "RELATIONSHIP": "Relación",
  "DOES_PASSENGER_APPOINTMENT": "¿Este pasajero tiene una cita?",
  "DOES_PASSENGER_WHEELCHAIR": "¿Este pasajero usa una silla de ruedas?",
  "WHAT_TYPE_WHEELCHAIR": "¿Qué tipo de silla de ruedas usan?",
  "WHAT_TYPE_WHEELCHAIR_YOU": "¿Qué tipo de silla de ruedas usa?",
  "WHEELCHAIR_TYPE": "Tipo de silla de ruedas",
  "YES": "Si",
  "NO": "No",
  "ADD_PASSENGER_SUB_TITLE": "¿Hay pasajeros adicionales viajando con usted?",
  "RAR_INVALID_DATE_MSG":
    "Para programar un viaje en el mismo día o al día siguiente, comuníquese directamente con MTM.",
  "RAR_NO_HEALTH_COVERAGE_MSG":
    "No es elegible para un viaje en la fecha seleccionada",
  "PICKUP_LOCATION_NAME": "Nombre de la ubicación de recogida",
  "PICKUP_LOCATION_NUMBER": "Número de teléfono de la ubicación de recogida",
  "APPOINTMENT_LOCATION_NAME": "Nombre de la ubicación de la cita",
  "APPOINTMENT_LOCATION_NUMBER":
    "Número de teléfono de la ubicación de la cita",
  "PHONE_NUMBER": "número de teléfono de esta ubicación",
  "LOCATION_NAME": "nombre del médico o el nombre de la instalación",
  "SN_TRANSFER": "Se puede transferir?",
  "SN_WC_WEIGHT":
    "¿Cuál es el peso total combinado para usted y su silla de ruedas?",
  "SN_ADD_WC": "Agregar silla de ruedas",
  "SN": "Alojamientos",
  "SN_USE_WHEELCHAIR": "¿Utilizas una silla de ruedas?",
  "WHEELCHAIR_INFO": "Información sobre sillas de ruedas",
  "WHAT_IS_MEDICAL_NUMBER": "¿Cuál es el número médico del pasajero?",
  "RAR_EXISTING_TRIP_WARNING":
    "¿Sabías que ya tienes un viaje solicitado ese día? ¿Necesitas otro viaje?",
  "RAR_WILL_CALL": "No se un tiempo",
  "RAR_MONTH_CALENDAR_WARNING_MSG":
    "Los viajes no se pueden solicitar con más de 6 meses de anticipación. Por favor, intente nuevamente más cerca de su cita.",
  "RAR_MULTI_COVERAGE_WARNING":
    "¿Qué plan de salud está utilizando para esta solicitud de transporte?",
  "RAR_WILL_CALL_MSG_1":
    "Al seleccionar esta opción, deberá comunicarse con MTM al",
  "RAR_WILL_CALL_MSG_2":
    "cuando esté listo para ser recogido. Su conductor puede tardar hasta una hora en llegar.",
  "RETURN_RIDE": "Paseo de regreso",
  "DO_YOU_NEED_RIDE": "¿Necesita un viaje de regreso?",
  "ADD_RETURN_RIDE": "Agregar viaje de regreso",
  "RETURN_TIME": "Hora de regreso",
  "ROUND_TRIP": "Ida y vuelta en",
  "TRANSFER": "Transferir",
  "RIDE_REQUEST_SUMMARY": "Resumen de solicitud de viaje",
  "WHEELCHAIR": "Silla de ruedas",
  "REASON": "Razón",
  "PICK_UP": "Recoger",
  "DROP_OFF": "Bajar ó dejar algo",
  "RAR_MONTH_CALENDAR_PREV_MSG":
    "Solo se pueden solicitar viajes para fechas futuras.",
  "RAR_MORE_TRIP_INFO_MSG": "Más información sobre tu viaje",
  "CALL": "Llamada",
  "ADDRESS_NOT_FOUND":
    "La dirección ingresada no se puede encontrar. Por favor ingrese una nueva dirección.",
  "RAR_PASSENGER_LIMIT_MSG":
    "Los pasajeros adicionales están limitados a 5. Si tiene más de 5 pasajeros, llame a MTM directamente al {{phoneNumber}}.",
  "CLEAR": "Claro",
  "CANCEL_STOP_ERROR_MSG":
    "Su cancelación no fue exitosa. Inténtalo de nuevo. Si esto persiste, comuníquese con MTM.",
  "RAR_TRIP_LIMIT_MSG":
    "Las solicitudes de transporte están limitadas a 5 citas. Si necesita transporte para más de 5 citas, llame a MTM directamente al {{phoneNumber}}",
  "RAR_REQUEST_SUCCESS_MSG":
    "Su solicitud de viaje para {{appointmentDate}} se ha enviado correctamente a MTM",
  "RAR_REQUEST_ERROR_MSG":
    "Su solicitud de viaje no fue exitosa. Inténtalo de nuevo. Si esto persiste, comuníquese con MTM.",
  "RAR_INCOMPLETE_DATA_WARNING":
    "Estás seguro de que quieres continuar? La solicitud de viaje no se ha completado y toda la información ingresada se perderá.",
  "RAR_GENERIC_ERROR_MSG":
    "La función de solicitud de viaje tiene problemas actualmente. Póngase en contacto con MTM directamente si esto persiste.",
  "APPOINTMENT_INFORMATION": "Información de cita",
  "DATE_SELECTION": "Selección de fecha",
  "SUMMARY": "Resumen",
  "HEADER_HELP_MSG":
    "¿Necesitas ayuda? ¡Llámenos y estaremos encantados de ayudarle!",
  "RAR_ONE_WAY_TRIP": "Viaje de ida el",
  "RAR_MULTI_STOP_TRIP": "Viaje de varias piernas el",
  "WILL_CALL": "Llamaré a MTM",
  "COMMUNICATION_PREFERENCES_NONE":
    "Actualice sus números de teléfono de Detalles de contacto para poder seleccionar una preferencia de comunicación.",
};
